import * as React from 'react'
import { compose, pure } from 'recompose'

import Icon, { IconType } from '../../atoms/Icon/Icon'
import TextLabel, { ColorType, SizeType } from '../../atoms/TextLabel/TextLabel'
import * as styles from './QuestionChoiceTrueFalse.css'

interface QuestionChoiceTrueFalseProps {
  isMaru: boolean
  white: boolean
  answerCount?: number
  answerTotalCount?: number
}

const QuestionChoiceTrueFalse: React.FunctionComponent<QuestionChoiceTrueFalseProps> = ({
  isMaru,
  white,
  answerCount,
  answerTotalCount
}) => {
  let icon: React.ReactElement<any> = <div />

  if (white) {
    icon = isMaru ? <Icon iconType={IconType.MARU_WHITE} /> : <Icon iconType={IconType.BATSU_WHITE} />
  } else {
    icon = isMaru ? <Icon iconType={IconType.MARU} /> : <Icon iconType={IconType.BATSU} />
  }

  return (
    <div className={styles.choice}>
      {icon}
      {answerCount !== undefined ? (
        <div className={styles.answerCount}>
          <TextLabel color={ColorType.WHITE} size={SizeType.LARGE}>
            {answerCount}
            <span className={styles.total}>/{answerTotalCount}人</span>
          </TextLabel>
        </div>
      ) : null}
    </div>
  )
}

export default compose<QuestionChoiceTrueFalseProps, QuestionChoiceTrueFalseProps>(pure)(QuestionChoiceTrueFalse)
